export default "__VITE_ASSET__D$lHnR$K__"